import { createContext, useContext, useState, useEffect } from 'react';

const InstanceContext = createContext(null);

export function InstanceProvider({ children }) {
  const [selectedInstance, setSelectedInstance] = useState(() => {
    // Optional: load from localStorage to persist between reloads
    const saved = localStorage.getItem('selectedInstance');
    return saved || '';
  });

  useEffect(() => {
    localStorage.setItem('selectedInstance', selectedInstance);
  }, [selectedInstance]);

  return (
    <InstanceContext.Provider value={{ selectedInstance, setSelectedInstance }}>
      {children}
    </InstanceContext.Provider>
  );
}

export function useInstance() {
  return useContext(InstanceContext);
}
